<template>
  <div @mouseenter='appMenuBotaoConteudoTratarSubmenu' @mouseleave='appMenuBotaoConteudoTratarSubmenu'>
    <transition :name="cpntFlagSubmenu === false || travado === true ? 'app-menu-anima' : 'app-submenu-anima'">
      <div v-show="mostrar === true && travado === false" class="app-menu-botoes" :class="(cpntFlagSubmenu === true ? 'sub-menu' : '') + ' ' + ($store.state.mobile === true ? 'app-menu-botoes-mobile' : '')" :data-time="time" :style="'width: ' + $store.state.tamanhoTela.width + ';'" @mouseleave='appMenuBotaoConteudoMostrarOcultar' @mouseenter='appMenuBotaoConteudoMostrarOcultar'>
        <!-- VERIFICA SE TEM TITULO PARA BOTÃO -->
        <div class="titulo" v-if="cpntFlagSubmenu === true">
          <!-- SETA O BOTÃO VOLTAR -->
          <div @click="appMenuBotaoConteudoTratarSubmenu({ type: 'click' }, 'LimparSubMenuMobile')" class="sub-menu-voltar">
            <svg class="fas fa-arrow-left"></svg>
          </div>

          <!-- SETA O TITULO DO BOTÃO -->
          <span v-if="cpntNome !== ''" v-html="cpntNome"></span>
        </div>

        <div v-if="$store.state.mobile === false && [ '', null, undefined ].indexOf(input) === -1 && Object.keys(input).length >= 1" class='app-menu-busca'>
          <RF-Input-Complite
            :data-time="time"

            :cpntStatus='input.status'
            :cpntId='input.id'
            :cpntTabIndex='input.tabIndex'
            :cpntNome='input.nome'
            :cpntValue='input.value'
            :cpntMensagem='input.mensagem'
            :cpntMensagemTipo='input.mensagemTipo'
            :cpntDisabled='input.disabled'
            :cpntMostrar='input.mostrar'
            :cpntExplica='input.explica'
            :cpntPlaceholder='input.placeholder'
            :cpntValueRef='input.valueRef'
            :cpntRouter='input.router'
            :cpntMethod='input.method'
            :cpntField='input.field'
            :cpntWhere='input.where'
            :cpntAddButForm='input.addButForm'
            :cpntKeyMostra='input.keyMostra'
            :cpntAutoComplete='input.autocomplete'

            ref='busca'
            :cpntOnChange='input.onChange'
            :cpntOnBlur='input.onBlur'
            :cpntOnRealizaBusca='input.onRealizaBusca'
            :cpntOnKeyPressEnter='input.onKeyPressEnter'
          ></RF-Input-Complite>
          <hr/>
        </div>

        <!-- SETA OS BOTOES DO MENU -->
        <div class="opcoes">
          <table>
            <tr v-for="(item, indexV) in cpntVetor" :key="'item-' + indexV" class="app-menu-item" :class="indexSub === indexV ? 'selecionado' : ''">
              <!-- SETA O ICONE DO FAVORITO -->
              <td class="favorito" v-if="cpntFlagSubmenu === true" :class="($store.state.favorito.filter(fav => fav.idmp === item.idmp).length === 1) ? 'favorito-selecionado' : ''">
                <span @click="appMenuBotaoAlterarFavoritos(item)">
                  <svg class="fa fa-star" aria-hidden="true"></svg>
                </span>
              </td>

              <td>
                <router-link tag="a" :to="[ '', null, undefined ].indexOf(item.rota) === -1 ? item.rota : ''">
                  <div @mouseleave='(event) => { appMenuBotaoConteudoSubMenuMostrarOcultar(event, indexV) }' @mouseenter='(event) => { appMenuBotaoConteudoSubMenuMostrarOcultar(event, indexV) }' @click='(event) => { appMenuBotaoConteudoSubMenuMostrarOcultar(event, indexV); appMenuBotaoConteudoAtualizaConteudo(item.rota) }'>
                    <table>
                      <tr>                      
                        <!-- SETA O ICONE DO PACOTE -->
                        <td class="icone">
                          <img :src='"/img/menu/" + item.idmp + ".png"' :alt='item.name' :title='item.name'>
                        </td>

                        <!-- SETA O NOME DO PACOTE -->
                        <td class="nome">
                          <!-- ({{ item.rota }}) -->
                          <div v-html='item.nome'></div>
                        </td>

                        <!-- SETA OS NUMEROS EXISTENTES PARA CADA BOTÃO -->
                        <td class="info app-menu-info" v-for='(info, indexI) in $store.state.menuInfo.filter(info => info.id === item.idmp)' :key="'item-' + indexV + '-info-' + indexI">
                          <div :title="info.title" :class='"app-menu-info--" + info.color' @click="appMenuBotaoConteudoAtualizaConteudo(info.busca + '--' + indexI)">
                            <router-link v-if="[ '', null, undefined ].indexOf(info.busca) === -1" :to='info.busca + "--" + indexI' :href='info.busca + "--" + indexI' target="_parent" tag='a' :key="'info-' + info.id + '-' + indexI" :title="info.title" :class='"app-menu-info--" + info.color'  > 
                              <span v-html="info.value"></span>
                            </router-link>
                            <span  v-else  v-html="info.value"></span>
                          </div>
                        </td>

                        <!-- ABERTURA SUBMENU -->
                        <td class="submenu" v-if="[ '', null, undefined ].indexOf(item.submenu) === -1">
                          <i class="fa fa-chevron-right" aria-hidden="true"></i>
                        </td>
                      </tr>
                    </table>
                  </div>
                </router-link>
              </td>
            </tr>
          </table>
        </div>

        <div class="menu-footer" v-if="cpntFlagSubmenu === false">
          <table>
            <tr>
              <td colspan="2">
                <div>
                  Subase Sistemas Estratégicos
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  <i class="fab fa-whatsapp" aria-hidden="true"></i>(41) 3076-7488
                </div>
                <!--
                <div>
                  <i class="fa fa-phone" aria-hidden="true"></i>(41) 3076-7488
                </div>
                -->
              </td>
              <td>
                <div class='rf-footer-logo'>
                  <img src="./img/logo_subase.png" style="width: 100px;">
                </div>
              </td>
            </tr>
          </table>
        </div>
      </div>
    </transition>

    <!-- VERIFICA SE DEVE MOSTRAR SUBMENU -->
    <template v-if="cpntFlagSubmenu === false && (mostrar === true && travado === false)">
      <!-- SETA O CONTEUDO DO SUB-MENU -->
      <Menu-Botoes
      :cpntNome="indexSub !== '' ? cpntVetor[indexSub].nome : ''"
      :cpntVetor="indexSub !== '' ? cpntVetor[indexSub].submenu : {}"
      :cpntFlagSubmenu="true"
      :cpntTravado="travado"
      :cpntMostrarOcultar="(event, index) => { appMenuBotaoConteudoSubMenuMostrarOcultar(event, index) }"
      :cpntMenuSetarFavorito="cpntMenuSetarFavorito"
      @ON_CHANGE_TRAVAR="appMenuBotaoTravar"
      ref='submenu'
      ></Menu-Botoes>

      <!-- SETA O BACKGROUND DA PAGINA -->
      <div v-if="mostrar === true" class="app-menu-bg" @click="appMenuBotaoConteudoForcarFechamento" @mouseenter='appMenuBotaoConteudoFecharMenuLeave'></div>

      <!-- SETA A FUNÇÃO PARA RECEBER O STATUS DO FLAG DO MENU DO VUEX -->
      <span :key="'vuex-menu-' + $store.state.atalhos['ALT+M'].mostrar">{{ appMenuBotaoConteudoAcaoExterna(true) }}</span>
    </template>
  </div>
</template>

<style scoped>

.app-menu-botoes {
  max-width: 272px;
  margin-top: 68px;
  height: calc(100% - 68px) !important;
  min-height: calc(100% - 68px) !important;
  max-height: calc(100% - 68px) !important;
  z-index: 2800;

  background-color: #fff;
  border: 1px solid #ccc;

  /* padding-top: 68px; */
  position: fixed;
  top: 0px;
  left: 0px;
  margin-left: -5px;
  padding-left: 8px;
  text-align: left;
  color: #222;
}
.app-menu-bg {
  position: fixed;
  z-index: 2797;
  top: 0px;
  width: 100%;
  height: 100%;
  margin-top: 68px;
  height: calc(100% - 68px) !important;
}
.sub-menu {
  padding-left: 15px;
  /* padding-top: 72px; */
  padding-top: 5px;

  -webkit-box-shadow: 5px 5px 11px 0px rgba(207,207,207,1);
  -moz-box-shadow: 5px 5px 11px 0px rgba(207,207,207,1);
  box-shadow: 5px 5px 11px 0px rgba(207,207,207,1);
  border-left: none;
}
  .sub-menu > div > .sub-menu-voltar {
    display: inline-block;
    cursor: pointer;
    margin-right: 5px;
  }
  .sub-menu > div > .sub-menu-voltar > svg {
    font-size: 18px;
    color: #666;
    vertical-align: -3px;
  }
    .sub-menu > div > .sub-menu-voltar > svg:hover {
      color: #222
    }

  .app-menu-botoes > .opcoes > table {
    width: 100%;
  }
  .app-menu-botoes > .opcoes > table > tr > td > a {
    color: #222;
  }
    .app-menu-botoes > .opcoes > table > tr > td > a:hover,
    .app-menu-botoes > .opcoes > table > tr > td > a:active,
    .app-menu-botoes > .opcoes > table > tr > td > a:focus {
      text-decoration: none;
    }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td {
    cursor: pointer;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item:hover > td,
  .app-menu-botoes > .opcoes > table > tr.app-menu-item.selecionado > td {
    background-color: #219dab;
    border-radius: 4px;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td.favorito {
    width: 30px;
    text-align: center;
    padding: 0px 6px;
    border-top-right-radius: 0px;
    border-bottom-right-radius: 0px;
  }

  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td.favorito {
    width: 29px;
    text-align: left;
    color: #dbdbdb;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td.favorito:hover,
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td.favorito.favorito-selecionado {
    color: #489fdf;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td.favorito ~ td {
    border-top-left-radius: 0px;
    border-bottom-left-radius: 0px;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td > a > div > table {
    width: 100%;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td:first-child {
    padding-left: 5px;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td:last-child {
    padding-right: 5px;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td > a > div > table > tr > td.icone {
    width: 20px;
    height: 20px;
  }
    .app-menu-botoes > .opcoes > table > tr.app-menu-item > td > a > div > table > tr > td.icone > img {
      width: 15px;
      height: 15px;
      filter: grayscale(100%);
    }
    .app-menu-botoes > .opcoes > table > tr.app-menu-item:hover > td > a > div > table > tr > td.icone > img,
    .app-menu-botoes > .opcoes > table > tr.app-menu-item.selecionado > td > a > div > table > tr > td.icone > img {
      filter: grayscale(0%);
    }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td > a > div > table > tr > td.nome {
    padding-left: 10px;
    
    font-size: 15px;
    font-weight: 400;
    line-height: 36px;
  }
    .app-menu-botoes > .opcoes > table > tr.app-menu-item:hover > td > a > div > table > tr > td.nome,
    .app-menu-botoes > .opcoes > table > tr.app-menu-item.selecionado > td > a > div > table > tr > td.nome {
      color: #fff;
    }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td > a > div > table > tr > td.info,
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td > a > div > table > tr > td.submenu {
    width: 1%;
    white-space: nowrap;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td > a > div > table > tr > td.submenu {
    padding-left: 2px;
  }
  .app-menu-botoes > .titulo {
    padding: 3px 0px;
    margin-bottom: 2px;
    margin-left: 5px;
    margin-right: 5px;
    color: var(--color-base-01);
    text-align: left;
    font-weight: 700;
    border-bottom: 1px solid #e1e1e8;
  }

.app-menu-botoes > .opcoes::-webkit-scrollbar {
  width: 8px;
  height: 8px;
  border-right: none;
}
.app-menu-botoes > .opcoes::-webkit-scrollbar-button {
  width: 0px;
  height: 0px;
}
.app-menu-botoes > .opcoes::-webkit-scrollbar-thumb {
  background: #e1e1e1;
  border: 0px none #ffffff;
  border-radius: 50px;
}
.app-menu-botoes > .opcoes::-webkit-scrollbar-thumb:hover {
  background: #ffffff;
}
.app-menu-botoes > .opcoes::-webkit-scrollbar-thumb:active {
  background: #ffffff;
}
.app-menu-botoes > .opcoes::-webkit-scrollbar-track {
  background: #f5eeee;
  border: 0px none #ffffff;
  border-radius: 50px;
}
.app-menu-botoes > .opcoes::-webkit-scrollbar-track:hover {
  background: #444444;
}
.app-menu-botoes > .opcoes::-webkit-scrollbar-track:active {
  background: #444444;
}
.app-menu-botoes > .opcoes::-webkit-scrollbar-corner {
  background: transparent;
}
.app-menu-botoes > .opcoes {
  overflow-y: auto;
  text-overflow: ellipsis;
  white-space: nowrap;
  text-decoration: none;
  padding-right: 5px;
}

.app-menu-botoes > .menu-footer {
  position: absolute;
  left: 0px;
  bottom: 0px;
  width: 100%;
  height: 65px;
  text-align: left;
  background-color: #fff;
  border-top: 1px solid #e1e1e8;

  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
  .app-menu-botoes > .menu-footer > table {
    width: 100%;
    margin: 8px 0px 25px 0px;
  }
    .app-menu-botoes > .menu-footer > table > tr:first-child > td {
      padding-bottom: 5px;
    }
    .app-menu-botoes > .menu-footer > table > tr > td {
      padding-left: 15px;
      padding-right: 15px;
    }
      .app-menu-botoes > .menu-footer > table > tr > td > .rf-footer-logo {
        text-align: right;
        opacity: 0.85;
      }
      .app-menu-botoes > .menu-footer > table > tr > td > div {
        font-size: var(--font-base-soma-12);
        color: var(--color-base-01);
        text-shadow: #fff 0 1px 0;
      }
        .app-menu-botoes > .menu-footer > table > tr > td > div > svg {
          margin-right: 8px;
          width: 10px;
        }

  .app-menu-busca > div {
    width: calc(100% - 5px);
    text-align: center;
    margin-bottom: 0px !important;
    margin-top: 5px;
  }
  .app-menu-busca > hr {
    margin: 5px 0px;
    padding: 0px;
  }
.app-menu-anima-enter-active {
  animation: animacao_menu_enter_active 0.15s;
}
.app-menu-anima-leave-active {
  animation: animacao_menu_leave_active 0.15s;
}
  @keyframes animacao_menu_enter_active {
    0%   { left: -275px; }
    10%  { left: -243px; }
    20%  { left: -216px; }
    30%  { left: -189px; }
    40%  { left: -162px; }
    50%  { left: -135px; }
    60%  { left: -108px; }
    70%  { left:  -81px; }
    80%  { left:  -54px; }
    90%  { left:  -27px; }
    100% { left:    0px; }
  }
  @keyframes animacao_menu_leave_active {
    0%   { left:    0px; }
    10%  { left:  -27px; }
    20%  { left:  -54px; }
    30%  { left:  -81px; }
    40%  { left: -108px; }
    50%  { left: -135px; }
    60%  { left: -162px; }
    70%  { left: -189px; }
    80%  { left: -216px; }
    90%  { left: -243px; }
    100% { left: -275px; }
  }

.app-submenu-anima-enter-active {
  animation: animacao_submenu_enter_active 0.15s;
}
.app-submenu-anima-leave-active {
  animation: animacao_submenu_leave_active 0.15s;
}

@media only screen and (max-width: 540px) {
  .sub-menu {
    left: 0px;
    z-index: 2801;
  }
  .sub-menu-voltar {
    /* display: block; */
  }
  @keyframes animacao_submenu_enter_active {
    0%   { left: -275px; }
    10%  { left: -243px; }
    20%  { left: -216px; }
    30%  { left: -189px; }
    40%  { left: -162px; }
    50%  { left: -135px; }
    60%  { left: -108px; }
    70%  { left:  -81px; }
    80%  { left:  -54px; }
    90%  { left:  -27px; }
    100% { left:    0px; }
  }
  @keyframes animacao_submenu_leave_active {
    0%   { left:    0px; }
    10%  { left:  -27px; }
    20%  { left:  -54px; }
    30%  { left:  -81px; }
    40%  { left: -108px; }
    50%  { left: -135px; }
    60%  { left: -162px; }
    70%  { left: -189px; }
    80%  { left: -216px; }
    90%  { left: -243px; }
    100% { left: -275px; }
  }
}

@media only screen and (min-width: 541px) {
  .sub-menu {
    left: 272px;
    z-index: 2798;
  }
  .sub-menu-voltar {
    display: none !important;
  }
  @keyframes animacao_submenu_enter_active {
    0%   { left: -272px; }
    10%  { left:   27px; }
    20%  { left:   54px; }
    30%  { left:   81px; }
    40%  { left:  108px; }
    50%  { left:  135px; }
    60%  { left:  162px; }
    70%  { left:  189px; }
    80%  { left:  216px; }
    90%  { left:  243px; }
    100% { left:  272px; }
  }
  @keyframes animacao_submenu_leave_active {
    0%   { left:  272px; }
    10%  { left:  243px; }
    20%  { left:  216px; }
    30%  { left:  189px; }
    40%  { left:  162px; }
    50%  { left:  135px; }
    60%  { left:  108px; }
    70%  { left:   81px; }
    80%  { left:   54px; }
    90%  { left:   27px; }
    100% { left: -272px; }
  }
}
@media only screen and (max-width: 480px) {
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td.favorito {
    display: none;
  }
  .app-menu-botoes > .opcoes > table > tr.app-menu-item > td > a > div > table > tr > td.icone {
    padding-left: 5px;
  }
}

@media only screen and (max-width: 599px) {
  .app-menu-busca {
    display: none;
  }
  .app-menu-botoes > .opcoes {
    height: calc(100% - 65px);
  }
}
@media only screen and (min-width: 600px) {
  .app-menu-botoes > .opcoes {
    height: calc(100% - 65px - 45px - 5px);
  }
}
.app-menu-botoes-mobile > .opcoes {
  height: 100%;
}
.app-menu-botoes-mobile > .menu-footer {
  display: none;
}
</style>

<style>
.app-menu-busca > div > div > .form-control {
  border: 1px solid #ccc !important;
}
.app-menu-busca > div > div > .form-control ~ .input-group-addon {
  background-color: #eee;
  border: 1px solid #ccc;
}
.app-menu-busca > div > ul {
  position: fixed;
  max-width: 255px !important;
  min-width: 255px !important;
}
  .app-menu-busca > div > ul > li {
    padding: 6px 10px !important;
  }
</style>

<script>
  export default {
    name: 'Menu-Botoes',
    props: {
      cpntVetor: {
        required: false,
        type: Object,
        default: function () {
          return this.$store.state.menu
        }
      },
      cpntNome: {
        required: false,
        type: String,
        default: function () {
          return ''
        }
      },
      cpntFlagSubmenu: {
        required: false,
        type: Boolean,
        default: function () {
          return false
        }
      },
      cpntMostrarOcultar: {
        required: false,
        default: function () {
          return null
        }
      },
      cpntMenuSetarFavorito: {
        required: true
      }
    },
    components: {
      'RF-Input-Complite': () => import('@/components/rf-geral/input-complite/RF-Input-Complite.vue')
    },
    data: function () {
      return {
        time: '',
        mostrar: false,
        travado: false,
        requestIdM: '',
        requestTpM: '',
        requestIdS: '',
        requestTpS: '',
        indexSub: '',
        input: {},
        mostrarVUEX: false
      }
    },
    destroyed: function () {
      // PEGA O ELEMENTO SOLICITADO
      var elemento = document.getElementById('app-menu-header-bt')

      // SETA A FUNÇÃO PARA OBSERVAR O PROCESSO
      if ([ '', null, undefined ].indexOf(elemento) === -1) {
        elemento.removeEventListener('click', this.appMenuBotaoConteudoMostrarOcultar)
        elemento.removeEventListener('mouseenter', this.appMenuBotaoConteudoMostrarOcultar)
        elemento.removeEventListener('mouseleave', this.appMenuBotaoConteudoMostrarOcultar)
      }
    },
    mounted: function () {
      if (this.cpntFlagSubmenu === false) {
        // PEGA O ELEMENTO SOLICITADO
        var elemento = document.getElementById('app-menu-header-bt')

        // SETA A FUNÇÃO PARA OBSERVAR O PROCESSO
        elemento.addEventListener('click', this.appMenuBotaoConteudoMostrarOcultar)
        elemento.addEventListener('mouseenter', this.appMenuBotaoConteudoMostrarOcultar)
        elemento.addEventListener('mouseleave', this.appMenuBotaoConteudoMostrarOcultar)

        // SETA O INPUT DE BUSCA
        this.input = {
          status: '',
          id: 'app-menu-busca',
          nome: '',
          value: '',
          tabIndex: 99999,
          mensagem: '',
          mensagemTipo: '',
          disabled: false,
          explica: null,
          placeholder: '',
          valueRef: '',
          router: '/menu/get/web-buscar/',
          field: {},
          keyMostra: [ 'nome' ],
          where: {},
          mostrar: true,
          autocomplete: 'off',
          onChange: (value) => {
            // SETA O VALOR RECEBIDO
            this.input.value = 'carregando...'

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()

            if (value.hasOwnProperty('rota') && value.rota !== '' && value.rota !== null) {
              // INICIA AS VARIAVEIS
              var link = value.rota
              var rota = ''

              // MONTA A ROTA DO MENU CORRETA PARA O VUE
              if (link.substring(0, 4) === 'http') {
                rota = link

                if (rota.indexOf('?') !== -1) {
                  rota += '&cts=' + this.$store.state.token.cts
                } else {
                  rota += '?cts=' + this.$store.state.token.cts
                }

                rota = '/' + this.$store.state.token.cts + '/cs/'  + encodeURI(window.btoa(JSON.stringify({ url: rota, post: {}, target: '' })))
              } else {
                rota = '/' + this.$store.state.token.cts + '/' + link
              }

              // REDIRECIONA PARA TELA SOLICITADA
              if (this.$store.state.buttonClickScroll.indexOf(this.input.id) === -1) {
                // ALTERA PARA PAGINA SOLICITADA
                this.$router.push(rota)

                // CHAMA A FUNÇÃO PARA ATUALIZAR O CONTEUDO SE FOR A MESMA PAGINA
                this.appMenuBotaoConteudoAtualizaConteudo(rota)
              } else {
                // CHAMA A FUNÇÃO PARA INFORMAR QUE A ROTA FOI ATUALIZADA
                this.$store.commit('SET_REFRESH_ROUTE', this.$route.name)

                // CHAMA A FUNÇÃO PARA FECHAR O CHAT
                if (Object.keys(this.$store.state.atalhos).length >= 1 && [ '', null, undefined ].indexOf(this.$store.state.atalhos['ALT+A']) === -1 && this.$store.state.atalhos['ALT+A'].mostrar === true) {
                  this.$store.commit('EXECUTE_ATALHO', 'ALT+A')
                }

                // ABRE UMA NOVA ABA
                setTimeout(() => { this.$store.state.OPEN_PAGE_CS(rota, '_blank') }, 400)
              }

              // FORÇA O FECHAMENTO DO MENU
              this.appMenuBotaoConteudoForcarFechamento()
            }

            // // SETA O VALOR RECEBIDO
            // this.input.value = ''

            // // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            // this.time = new Date().getTime()
          }
        }
      }

      // SETA SE DEVE OU NÃO MOSTRAR
      this.mostrarVUEX = this.$store.state.atalhos['ALT+M'].mostrar
    },
    methods: {
      appMenuBotaoConteudoAcaoExterna: function () {
        if (this.mostrarVUEX !== this.$store.state.atalhos['ALT+M'].mostrar) {
          // SETA SE DEVE OU NÃO MOSTRAR
          this.mostrarVUEX = this.$store.state.atalhos['ALT+M'].mostrar

          // VERIFICA SE DEVE ABRIR OU FECHAR O MENU
          switch (this.mostrar + '_' + this.$store.state.atalhos['ALT+M'].mostrar) {
            case 'false_true':
              this.appMenuBotaoConteudoMostrarOcultar({ type: 'click' })
              break

            case 'true_false':
              this.appMenuBotaoConteudoForcarFechamento()
              break
          }
        }
      },
      appMenuBotaoConteudoForcarFechamento: function () {
        // LIMPA A VARIAVEL PARA PODER FECHAR
        this.requestTpM = ''
        this.requestTpS = ''

        // CHAMA A FUNÇÃO PARA FECHAR
        this.appMenuBotaoConteudoMostrarOcultar({ type: 'mouseleave', forcar: true })
      },
      appMenuBotaoConteudoMostrarOcultar: function (event, requestIdM = '') {
        if (this.cpntFlagSubmenu === false) {
          if (requestIdM === '' || requestIdM === this.requestIdM) {
            // PEGA O TIPO DO EVENTO SOLICITADO
            var tipo = event.type

            // SETA O REQUEST DA REQUISIÇÃO
            requestIdM = (Math.floor(Math.random() * (9999 - 1000)) + 1000)
            
            // SETA O REQUESTID ATUALIZADO
            this.requestIdM = requestIdM

            // VERIFICA SE DEVE MOSTRAR OU NÃO
            if (tipo === 'click' && this.mostrar === false) {
              // MOSTRA O MENU SOLICITADO
              this.mostrar = true
              
              // SETA O TIPO DESEJADO
              this.requestTpM = tipo
            } else if (tipo === 'click' && this.mostrar === true && (this.requestTpM !== 'click' && this.requestTpS !== 'click')) {
              // MOSTRA O MENU SOLICITADO
              this.mostrar = true
              
              // SETA O TIPO DESEJADO
              this.requestTpM = tipo
            } else if (tipo === 'click' && this.mostrar === true && this.requestTpM === 'click') {
              this.appMenuBotaoConteudoFecharMenu(null, requestIdM, false, event.forcar === true)
            } else if ((this.requestTpM !== 'click' && this.requestTpS !== 'click') && (tipo === 'mouseenter' && this.mostrar === false)) {
              // MOSTRA O MENU SOLICITADO
              this.mostrar = true
              
              // SETA O TIPO DESEJADO
              this.requestTpM = tipo
            } else if ((this.requestTpM !== 'click' && this.requestTpS !== 'click') && (tipo === 'mouseleave' && this.mostrar === true)) {
              this.appMenuBotaoConteudoFecharMenu(null, requestIdM, false, event.forcar === true)
            }
          }
        }
      },
      appMenuBotaoConteudoFecharMenu: function (callback = null, requestIdM = '', submenu = false, fechar = true, tentativa = 0) {
        // AGUARDA UNS MS PARA FECHAR O MENU
        setTimeout(() => {
          if (requestIdM === this.requestIdM) {
            if (tentativa < 2 && fechar === false && this.indexSub !== '') {
              setTimeout(() => { this.appMenuBotaoConteudoFecharMenu(callback, requestIdM, submenu, fechar, (tentativa + 1)) }, 100)
            } else {
              // CHAMA A FUNÇÃO PARA FECHAR O SUBMENU
              this.appMenuBotaoConteudoFecharSubmenu(null, this.requestIdS)

              // MOSTRA O MENU SOLICITADO
              this.mostrar = false
              
              // SETA O TIPO DESEJADO
              this.requestTpM = ''

              // SETA O VALOR RECEBIDO
              this.input.value = ''
      
              // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
              this.time = new Date().getTime()
  
              // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
              if (callback !== null && typeof callback === 'function') {
                callback()
              }
            }
          }
        }, 150)
      },
      appMenuBotaoConteudoSubMenuMostrarOcultar: function (event, indexSub, requestIdS = '') {
        if (this.cpntFlagSubmenu === false) {
          if (requestIdS === '' || requestIdS === this.requestIdS) {
            // PEGA O TIPO DO EVENTO SOLICITADO
            var tipo = event.type
  
            // SETA O REQUEST DA REQUISIÇÃO
            requestIdS = (Math.floor(Math.random() * (9999 - 1000)) + 1000)
            
            // SETA O REQUESTID ATUALIZADO
            this.requestIdM = requestIdS
            this.requestIdS = requestIdS
  
            // VERIFICA SE DEVE MOSTRAR OU NÃO
            if ([ '', null, undefined ].indexOf(indexSub) === -1) {
              // LIMPA O VALOR DO CAMPO
              if (indexSub === 'LimparSubMenuMobile') {
                indexSub = ''
              }

              if (tipo === 'click' && this.indexSub === '') {
                // // MOSTRA O MENU SOLICITADO
                // this.indexSub = indexSub
                
                // // SETA O TIPO DESEJADO
                // this.requestTpS = tipo
                this.appMenuBotaoConteudoFecharSubmenu(null, requestIdS, indexSub, tipo)
              } else if (tipo === 'click' && this.indexSub !== '' && this.requestTpS !== 'click') {
                // // MOSTRA O MENU SOLICITADO
                // this.indexSub = indexSub
                
                // // SETA O TIPO DESEJADO
                // this.requestTpS = tipo
                this.appMenuBotaoConteudoFecharSubmenu(null, requestIdS, indexSub, tipo)
              } else if (tipo === 'click' && this.indexSub !== indexSub && this.requestTpS === 'click') {
                // // MOSTRA O MENU SOLICITADO
                // this.indexSub = indexSub
                
                // // SETA O TIPO DESEJADO
                // this.requestTpS = tipo
                this.appMenuBotaoConteudoFecharSubmenu(null, requestIdS, indexSub, tipo)
              } else if (tipo === 'click' && this.indexSub === indexSub && this.requestTpS === 'click') {
                // MOSTRA O MENU SOLICITADO
                this.indexSub = ''
                
                // SETA O TIPO DESEJADO
                this.requestTpS = tipo

                // this.appMenuBotaoConteudoFecharSubmenu(null, requestIdS)
                this.appMenuBotaoConteudoFecharMenu(null, this.requestIdM, false, false)
              } else if (tipo !== 'click' && this.indexSub !== indexSub && this.requestTpS !== 'click') {
                // // MOSTRA O MENU SOLICITADO
                // this.indexSub = indexSub
                
                // // SETA O TIPO DESEJADO
                // this.requestTpS = tipo
                this.appMenuBotaoConteudoFecharSubmenu(null, requestIdS, indexSub, tipo)
              } else if (this.requestTpS !== 'click' && (tipo === 'mouseenter' && this.indexSub === '')) {
                // // MOSTRA O MENU SOLICITADO
                // this.indexSub = indexSub
                
                // // SETA O TIPO DESEJADO
                // this.requestTpS = tipo
                this.appMenuBotaoConteudoFecharSubmenu(null, requestIdS, indexSub, tipo)
              } else if (this.requestTpS !== 'click' && (tipo === 'mouseleave' && this.indexSub !== '' && indexSub === '')) {
                // MOSTRA O MENU SOLICITADO
                this.indexSub = ''
                
                // SETA O TIPO DESEJADO
                this.requestTpS = tipo

                // this.appMenuBotaoConteudoFecharSubmenu(null, requestIdS)
                this.appMenuBotaoConteudoFecharMenu(null, this.requestIdM, false, false)
              }
            }
          }
        }
      },
      appMenuBotaoConteudoTratarSubmenu: function (event, index = '') {
        if (this.cpntFlagSubmenu === true && this.cpntMostrarOcultar !== null) {
          this.cpntMostrarOcultar(event, index)
        }
      },
      appMenuBotaoConteudoFecharSubmenu: function (callback = null, requestIdS = '', indexSub = '', requestTpS = '') {
        // AGUARDA UNS MS PARA FECHAR O MENU
        setTimeout(() => {
          if (requestIdS === this.requestIdS) {
            // MOSTRA O MENU SOLICITADO
            this.indexSub = indexSub
            
            // SETA O TIPO DESEJADO
            this.requestTpS = requestTpS
  
            // EXECUTA A FUNÇÃO CALLBACK SE RECEBEU
            if (callback !== null && typeof callback === 'function') {
              callback()
            }
          }
        }, 150)
      },
      appMenuBotaoTravar: function () {
        // SETA A FUNÇÃO DE TRAVADO
        this.travado = true

        // SETA A FUNÇÃO DE TRAVAR
        if (this.cpntFlagSubmenu === true) {
          this.$emit('ON_CHANGE_TRAVAR')
        } else {
          setTimeout(() => {
            // SETA O REQUESTID ATUALIZADO
            this.requestIdM = ''
            this.requestIdS = ''
            this.requestTpM = ''
            this.requestTpS = ''
            this.indexSub = ''
            this.input.value = ''  

            // OCULTA O MENU DA TELA
            this.mostrar = false

            // DESTRAVA O CAMPO
            this.travado = false

            // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
            this.time = new Date().getTime()
          }, 1000)
        }
      },
      appMenuBotaoConteudoAtualizaConteudo: function (rota) {
        if (this.cpntFlagSubmenu === true) {
          this.appMenuBotaoTravar()
        }

        if (this.cpntFlagSubmenu === true && rota === this.$route.path) {
          // SETA O FLAG PARA ATUALIZAR O COMPONENT
          this.$store.commit('SET_TIME_CONTEUDO', this.$router.resolve(rota))
          
          // VERIFICA SE O MENU ESTÁ ABERTO
          if (this.$store.state.atalhos['ALT+M'].mostrar === true) {
            this.$store.commit('EXECUTE_ATALHO', 'ALT+M')
          }
  
          // ABRE O CHAT, SE ELE ESTIVER FECHADO
          if (rota.indexOf('/reg-atendimentos') === -1 && [ '', null, undefined ].indexOf(this.$store.state.atalhos['ALT+A']) === -1 && this.$store.state.atalhos['ALT+A'].mostrar === true) {
            this.$store.commit('EXECUTE_ATALHO', 'ALT+A')
          }
        }
      },
      appMenuBotaoConteudoFecharMenuLeave: function () {
        if (this.requestTpM !== 'click' && this.requestTpS !== 'click') {
          this.appMenuBotaoConteudoForcarFechamento()
        } else if (this.requestTpM === 'click' && this.requestTpS !== 'click') {
          this.appMenuBotaoConteudoFecharSubmenu(null, this.requestIdS)
        }
      },
      appMenuBotaoAlterarFavoritos: function (item) {
        this.cpntMenuSetarFavorito(item.idmp)
      },
      appMenuBotaoFocusCampoBusca: function () {
        if (this.mostrar === true) {
          if ([ '', null, undefined ].indexOf(this.$refs.busca) === -1 && [ '', null, undefined ].indexOf(this.$refs.busca.onFocusField) === -1) {
            this.$refs.busca.onFocusField()
          }
        }
      }
    },
    watch: {
      cpntTravado: function () {
        this.travado = this.cpntTravado
      },
      indexSub: function () {
        if ([ '', null, undefined ].indexOf(this.$refs) === -1 && [ '', null, undefined ].indexOf(this.$refs.submenu) === -1) {
          // VERIFICA SE DEVE MOSTRAR OU NÃO O CAMPO
          this.$refs.submenu.mostrar = [ '', null, undefined ].indexOf(this.indexSub) === -1
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.$refs.submenu.time = new Date().getTime()
        }

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.input) === -1 && Object.keys(this.input).length >= 1) {
          // SETA O VALOR RECEBIDO
          this.input.value = ''
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
          this.appMenuBotaoFocusCampoBusca()
        }
      },
      mostrar: function () {
        if (this.cpntFlagSubmenu === false && this.mostrar !== this.$store.state.atalhos['ALT+M'].mostrar) {
          this.$store.commit('EXECUTE_ATALHO', 'ALT+M')
        }

        // VERIFICA SE O CAMPO EXISTE
        if ([ '', null, undefined ].indexOf(this.input) === -1 && Object.keys(this.input).length >= 1) {
          // SETA O VALOR RECEBIDO
          this.input.value = ''
  
          // SETA O TIME PARA FORÇAR O CARREGAMENTO DOS COMPONENTS
          this.time = new Date().getTime()

          // CHAMA A FUNÇÃO PARA DAR FOCUS NO CAMPO
          this.appMenuBotaoFocusCampoBusca()
        }
      }
    }
  }
</script>
